import React from 'react';

import useThunkReducer from 'js/sign-components/signature-modal/contexts/signature-modal/use-thunk-reducer';
import Reducer from 'hellospa/common/reducers/condor';

export const Context = React.createContext({
  notices: [],
});

export const ContextProvider = (props) => {
  const initialState = React.useContext(Context);
  const [state, dispatch] = useThunkReducer(Reducer, initialState);
  const value = React.useMemo(() => ({ state, dispatch }), [dispatch, state]);

  return (
    <Context.Provider value={value}>
      {props.children}
    </Context.Provider>
  );
};

export const withCondorContextProvider = (Component) => {
  return (
    // eslint-disable-next-line react/display-name
    React.forwardRef((props, ref) => (
      <ContextProvider>
        <Component {...props} ref={ref} />
      </ContextProvider>
    ))
  );
};

export const useCondorContext = () => React.useContext(Context);
export const withCondorContext = (Component) => {
  return (
    // eslint-disable-next-line react/display-name
    React.forwardRef((props, ref) => (
      <Context.Consumer>
        {(value) => (
          <Component {...props} condorContext={value} ref={ref} />
        )}
      </Context.Consumer>
    ))
  );
};
